import { Tab, Tabs, Typography } from '@material-ui/core';
import { BloqueioResponse } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { LgSpace } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from 'store';
import DetalhesOperacaoBloqueio from './detalhesOperacaoBloqueio';
import HistoricoBloqueio from './historicoBloqueio';

type RouteProps = {
  bloqueioId: string;
};

const mapStateToProps = (state: RootState) => ({
  investidorApi: state.investidorApi,
});

type Props = RouteComponentProps<RouteProps> & ReturnType<typeof mapStateToProps>;

const DetalhesBloqueio: React.FC<Props> = (props) => {
  const { bloqueioId } = props.match.params;
  const {
    investidorApi: { getBloqueio },
  } = props;
  const [bloqueio, setBloqueio] = useState<BloqueioResponse>();
  const [tabValue, setTabValue] = useState<number>(0);
  const dispatch = useDispatch();

  useEffect(() => {
    getBloqueio(dispatch, bloqueioId, true).then(setBloqueio).catch();
  }, [bloqueioId, dispatch, getBloqueio]);

  return !!bloqueio ? (
    <div style={{ marginRight: 40 }}>
      <Typography variant="h1">{'Bloqueio'}</Typography>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Informações de bloqueio" />
          <Tab label="Histórico" />
        </Tabs>
      </HorizontalAppBar>
      {tabValue === 0 && <DetalhesOperacaoBloqueio bloqueio={bloqueio} />}
      {tabValue === 1 && <HistoricoBloqueio bloqueio={bloqueio} />}
    </div>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(withRouter(DetalhesBloqueio));
